// extracted by mini-css-extract-plugin
export default {"property":"Property_property__uxMDl","propertyName":"Property_propertyName__PrXJ2","info":"Property_info__s-XMn"};